export default __webpack_public_path__ + "static/media/ic_xrp_40.b70f2374.svg";